import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useNas from "../../../../hooks/useNas";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import FilterReset from "../../../../components/FilterReset";
import { searchPayload, convertedValue } from "../../../../utils/common";
import { OperatorConstants } from "../../../../constants/operator.constants";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import CustomTextField from "../../../../components/CustomTextField";
import { useDialog } from "../../../../contexts/DialogContext";
import useInterface from "../../../../hooks/useInterface";
const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const statusOptions = [
  {
    label: "Active",
    value: "A",
  },
  {
    label: "InActive",
    value: "INA",
  },
];

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialValues = {
    nasNameOperator: "eq",
    serviceNameOperator: "eq",
    interfaceOperator: "eq",
    statusOperator: "eq",
    nasName: [],
    serviceName: "",
    interface: "",
    status: [],
  };

  const { fields, payload, setPayload, setFilterResetFunc } = props;

  const { autoSearchNas, nasAutoSearchResults, isLoadingAutoSearch } = useNas();

  const { autoSearchInterface, interfaceAutoSearchResults } = useInterface();

  const [interfaceOptions, setInterfaceOptions] = useState([]);
  const [interfacePayload, setInterfacePayload] = useState(currentPayload);

  const [interfaceMultiValue, setInterfaceMultiValue] = useState(false);

  const [nasPayload, setNasPayload] = useState(currentPayload);
  const [nasOptions, setNasOptions] = useState([]);
  const [nasMultiValue, setNasMultiValue] = useState(false);
  const [statusMultiValue, setStatusMultiValue] = useState(false);
  const [defaultNas, setDefaultNas] = useState([]);

  const [defaultStatus, setDefaultStatus] = useState([]);

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const nasOpValue = watch("nasNameOperator");

  const statusOpValue = watch("statusOperator");

  const onSubmit = async (data) => {
    try {
      let filters = [];

      if (data.nasName != null && Object.keys(data.nasName).length != 0) {
        filters.push({
          fieldName: "nasId",
          fieldValue: convertedValue(data.nasName, "value").join(","),
          op: data.nasNameOperator,
          dataType: "int",
          condition: "and",
          isJoin: true,
        });
      }
      if (data.serviceName != "" && data.serviceName != null) {
        filters.push({
          fieldName: "serviceName",
          fieldValue: data.serviceName,
          op: data.serviceNameOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.interface != "" && data.interface != null) {
        filters.push({
          fieldName: "interface",
          fieldValue: data.interface,
          op: data.interfaceOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.status != null && Object.keys(data.status).length != 0) {
        filters.push({
          fieldName: "status",
          fieldValue: convertedValue(data.status, "value").join(","),
          op: data.statusOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  useEffect(() => {
    if (nasOpValue == "in" || nasOpValue == "nin") {
      setDefaultNas([]);
      setValue("nasName", []);
      setNasMultiValue(true);
    } else {
      setDefaultNas({});
      setValue("nasName", {});
      setNasMultiValue(false);
    }
  }, [nasOpValue]);

  useEffect(() => {
    if (statusOpValue == "in" || statusOpValue == "nin") {
      setDefaultStatus([]);
      setValue("status", []);
      setStatusMultiValue(true);
    } else {
      setDefaultStatus({});
      setValue("status", {});
      setStatusMultiValue(false);
    }
  }, [statusOpValue]);

  const fetchNas = async () => {
    await autoSearchNas(nasPayload);
  };
  useEffect(() => {
    fetchNas();
  }, [nasPayload]);

  useEffect(() => {
    console.log(nasAutoSearchResults, "nasAutoSearchResults");
    if (nasAutoSearchResults.data.length !== 0) {
      setNasOptions([...nasOptions, ...nasAutoSearchResults.data]);
    }
  }, [nasAutoSearchResults]);

  const fetchInterface = async () => {
    await autoSearchInterface(interfacePayload);
  };
  useEffect(() => {
    fetchInterface();
  }, [interfacePayload]);

  useEffect(() => {
    console.log(interfaceAutoSearchResults, "interfaceAutoSearchResults");
    if (interfaceAutoSearchResults.data.length !== 0) {
      setInterfaceOptions([...interfaceOptions, ...interfaceAutoSearchResults.data]);
    }
  }, [interfaceAutoSearchResults]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} pt={8}>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="nasNameOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <SearchableAutoComplete
                control={control}
                data={nasOptions}
                label={t("nas_name")}
                payload={nasPayload}
                setPayload={setNasPayload}
                loading={isLoadingAutoSearch}
                name="nasName"
                multiple={nasMultiValue}
                defaultValue={defaultNas}
                hasNextPage={nasAutoSearchResults.paging.hasNextPage}
              />
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="serviceNameOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.string).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item md={6}>
              <CustomTextField
                label={t("serviceNames")}
                name="serviceName"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="interfaceNameOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <SearchableAutoComplete
                control={control}
                data={interfaceOptions}
                label={t("interfaces_name")}
                payload={interfacePayload}
                setPayload={setNasPayload}
                loading={isLoadingAutoSearch}
                name="interfaceName"
                multiple={interfaceMultiValue}
                defaultValue={defaultNas}
                hasNextPage={interfaceAutoSearchResults.paging.hasNextPage}
              />
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="statusOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <SearchableAutoComplete
                control={control}
                data={statusOptions}
                label={t("Status")}
                payload={null}
                setPayload={null}
                loading={false}
                name="status"
                multiple={statusMultiValue}
                defaultValue={defaultStatus}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={reset} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
